import React from 'react';

export default function BatchCardSkeleton() {
  return (
    <div className="w-full max-w-[416px] bg-white shadow-md animate-pulse">
      <div className="flex flex-col gap-4 p-4 sm:p-5">
        {/* Title + Badge */}
        <div className="flex justify-between items-start gap-1">
          <div className="h-5 w-40 bg-gray-200 rounded" />
          <div className="h-5 w-16 bg-gray-200 rounded" />
        </div>

        {/* Batch Time + Start Date */}
        <div className="flex justify-between w-full">
          <div>
            <div className="h-3 w-16 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-24 bg-gray-200 rounded" />
          </div>
          <div>
            <div className="h-3 w-20 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-28 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Venue + Language */}
        <div className="flex justify-between w-full">
          <div>
            <div className="h-3 w-14 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-20 bg-gray-200 rounded" />
          </div>
          <div>
            <div className="h-3 w-16 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-16 bg-gray-200 rounded" />
          </div>
        </div>
      </div>

      {/* Price + Button */}
      <div className="flex justify-between items-center w-full pr-4 sm:pr-5 pb-4 sm:pb-5">
        <div className="h-6 w-28 bg-gray-200 rounded" />
        <div className="h-8 w-24 bg-gray-200 rounded" />
      </div>
    </div>
  );
}
